import React from "react";
import {observer} from "mobx-react-lite";
import appStore from "../storage/AppStore";

const LanguageSelector = () => {
  
  return (
    <div className="dropstart">
      <button type="button"
              className="theme-switcher btn btn-icon btn-lg btn-outline-secondary fs-lg border-0 rounded-circle animate-scale"
              data-bs-toggle="dropdown" aria-expanded="false" aria-label="Toggle theme (light)">
                    <span className="theme-icon-active d-flex animate-target">
                      {appStore.userLanguage?.icon}
                    </span>
      </button>
      <ul className="dropdown-menu" style={{"--cz-dropdown-minWidth": "9rem"}}>
        {appStore.languages.map((language) => (
          <li key={language.id}>
            <button type="button"
                    className={appStore.user.language === language.id ? "dropdown-item active" : "dropdown-item"}
                    data-bs-theme-value="light"
                    aria-pressed="false" onClick={() => {
              if (appStore.user.language !== language.id) {
                appStore.setLanguage(language.id)
              }
            }}>
                        <span className="theme-icon d-flex fs-base me-2">
                          {language.icon}
                        </span>
              <span className="theme-label">{language.label}</span>
              <i className="item-active-indicator ci-check ms-auto"/>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
export default observer(LanguageSelector);
